/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/baby'
export default icon
